export function hasFutureEvents(value) {
  return value ? `FUTURE APPOINTMENTS` : ` `
}
